import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import ReViewParadan from "./ReViewParadan";
import {
  change_Lang,
  EveryTimeTo_English,
} from "../../../actions/Helper_action";
import { Update_Paradan, View_Paradan } from "../../../actions/Invoice_action";
import { Get_List_Agents } from "../../../actions/Agent_action";
export class ReView_Paradans extends Component {
  render() {
    const {
      paradan_view,
      lang,
      change_Lang,
      Update_Paradan,
      EveryTimeTo_English,
      Get_List_Agents,
      list_agents,
      handleCancel,
    } = this.props;
    return (
      <Fragment>
        <div className="container-fluid">
          <ReViewParadan
            paradan_view={paradan_view}
            lang={lang}
            change_Lang={change_Lang}
            Update_Paradan={Update_Paradan}
            EveryTimeTo_English={EveryTimeTo_English}
            Get_List_Agents={Get_List_Agents}
            list_agents={list_agents}
            handleCancel={handleCancel}
          />
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lang: state.HelperReducer.lang,
    paradan_view: state.InvoiceReducer.paradan_view,
    list_paradan: state.InvoiceReducer.list_paradan,
    list_agents: state.AgentReducer.list_agents,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    change_Lang: (key) => dispatch(change_Lang(key)),
    EveryTimeTo_English: (keys) => dispatch(EveryTimeTo_English(keys)),
    Update_Paradan: (id, data) => dispatch(Update_Paradan(id, data)),
    View_Paradan: (id, index) => dispatch(View_Paradan(id, index)),
    Get_List_Agents: () => dispatch(Get_List_Agents()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReView_Paradans);
